import { render, staticRenderFns } from "./noteSend.vue?vue&type=template&id=64cb7a40&scoped=true&"
import script from "./noteSend.vue?vue&type=script&lang=js&"
export * from "./noteSend.vue?vue&type=script&lang=js&"
import style0 from "./noteSend.vue?vue&type=style&index=0&id=64cb7a40&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb7a40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64cb7a40')) {
      api.createRecord('64cb7a40', component.options)
    } else {
      api.reload('64cb7a40', component.options)
    }
    module.hot.accept("./noteSend.vue?vue&type=template&id=64cb7a40&scoped=true&", function () {
      api.rerender('64cb7a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/notes/noteSend.vue"
export default component.exports